document.addEventListener("DOMContentLoaded", function () {
    const navbar = document.getElementById("gh-head");

    if (!navbar) {
        console.error("Navbar not found! Check `default.hbs`.");
        return;
    }

    window.addEventListener("scroll", function () {
        if (window.scrollY > 0) {
            navbar.classList.add("compact");
        } else {
            navbar.classList.remove("compact");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.querySelector("menu-toggle");
  const navList = document.querySelector("nav-list");

  if (menuToggle && navList) {
    menuToggle.addEventListener("click", function () {
      navList.classList.toggle("show-menu");
    });
  }
});